import { NextImage } from '../../../shared/types/CommonVM';

const CROSS_ICON_SRC =
  'https://dom-content-vault-prod-cdn-assets.porter.in/cross_icon_grey_a85a70f29a/cross_icon_grey_a85a70f29a.svg';

export const close_icon: NextImage = {
  src: CROSS_ICON_SRC,
  width: 14,
  height: 14,
  alt: 'Cross Icon',
};
